import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { SharedModule } from '../../../shared/shared.module';
import { PermissionsModule } from '../permissions/permissions.module';
import { MicroscopeRoutingModule } from './microscope-routing.module';
import { MicroscopeEditScreenComponent } from './screens/edit/microscope-edit-screen.component';

@NgModule({
  declarations: [MicroscopeEditScreenComponent],
  imports: [
    CommonModule,
    HeaderComponent,
    MicroscopeRoutingModule,
    PermissionsModule,
    SharedModule,
  ],
})
export class MicroscopeModule {}
